export default __webpack_public_path__ + "static/media/all-color-books.e4df3d33.png";